module.exports = __webpack_public_path__ + "img/61-l.376c5696.png";